<template>
  <div class="schema">
  <script type="application/ld+json">
    {
      "@context": "https://schema.org/",
      "@type": "HowTo",
      "name": "An easy way to earn a passive income",
      "description": "On Income Marketplace you can invest in loans and earn passive income. On Income Marketplace you can invest in loans and earn a passive income. We are committed to transparency and investor protection.",
      "step": [{
        "@type": "HowToStep",
        "text": "To get started you need to create an account with Income Marketplace",
        "image": "https://getincome.com/img/register.jpg",
        "name": "Register",
        "url": "https://getincome.com/register"
      },{
        "@type": "HowToStep",
        "text": "Add funds to your investor account by bank transfer.",
        "image": "https://getincome.com/img/deposit.jpg",
        "name": "Add funds"
      },{
        "@type": "HowToStep",
        "text": "Invest by manually choosing loans or by creating an auto invest strategy with parameters chosen by you.",
        "image": "https://getincome.com/img/invest.jpg",
        "name": "Invest"
      },{
        "@type": "HowToStep",
        "text": "See your investment grow and receive principal and interest payments to your account.",
        "image": "https://getincome.com/img/get-income.jpg",
        "name": "Get Income"
      }]
    }
  </script>
  </div>
</template>

<script>
export default {
  name: 'How-To-Schema'
}
</script>
